import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SettingsContextType {
  hideBoardTab: boolean;
  setHideBoardTab: (hide: boolean) => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

interface SettingsProviderProps {
  children: ReactNode;
}

export function SettingsProvider({ children }: SettingsProviderProps) {
  const [hideBoardTab, setHideBoardTab] = useState(true); // Default to hidden

  return (
    <SettingsContext.Provider value={{ hideBoardTab, setHideBoardTab }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
} 